// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__omOm2","segment":"Nav_segment__rYXA7","segment_texts":"Nav_segment_texts__+Hn6b","my_img":"Nav_my_img__D9iLF"};